export function transformApiResponse(apiResponseArray) {
  if (!Array.isArray(apiResponseArray)) {
    console.error('Invalid API response. Expected an array of objects.')
    return []
  }

  const formatKey = key => {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, str => str.toUpperCase())
  }

  return apiResponseArray
    .map(apiResponse => {
      if (typeof apiResponse !== 'object' || apiResponse === null) {
        console.error('Invalid object in array. Expected an object.')
        return null
      }

      return Object.entries(apiResponse)
        .filter(([, value]) => value !== null && value !== '')
        .map(([key, value]) => ({
          title: formatKey(key),
          content: value,
        }))
    })
    .filter(normalizedObj => normalizedObj !== null)
}
